import { useState } from 'react';

export default function HeroSection() {
  const [searchValue, setSearchValue] = useState('');

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20fashionable%20young%20Asian%20woman%20filming%20a%20style%20video%20with%20smartphone%20in%20a%20bright%20minimalist%20modern%20loft%20studio%20with%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20clothing%20rack%20with%20stylish%20outfits%20in%20background%2C%20clean%20aesthetic%2C%20warm%20beige%20and%20cream%20tones%2C%20lifestyle%20photography%20style%2C%20soft%20and%20dreamy%20atmosphere&width=1800&height=1200&seq=mogu-hero-bg&orientation=landscape"
        alt="mogu视频 - 时尚视频购物平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 text-center animate-fade-in-up">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
          边看边买，发现你的
          <span className="text-primary-400">时尚灵感</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          mogu视频汇聚海量穿搭教程、美妆测评、潮流单品视频，
          <br className="hidden sm:block" />
          让你在沉浸式视频中发现最新时尚趋势，边看边买，轻松变美
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto mb-6">
          <div className="relative w-full sm:flex-1">
            <div className="w-5 h-5 flex items-center justify-center absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400">
              <i className="ri-search-line text-lg"></i>
            </div>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="搜索你感兴趣的视频内容..."
              className="w-full pl-11 pr-4 py-3 bg-white/95 backdrop-blur-sm rounded-full text-sm text-foreground-800 placeholder:text-foreground-400 outline-none border-2 border-transparent focus:border-primary-400 transition-all"
            />
          </div>
          <button className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-all whitespace-nowrap">
            搜索
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-white/70">
          <span>热门搜索：</span>
          <a href="#" className="px-2.5 py-1 bg-white/10 hover:bg-white/20 rounded-full transition-colors whitespace-nowrap">早春穿搭</a>
          <a href="#" className="px-2.5 py-1 bg-white/10 hover:bg-white/20 rounded-full transition-colors whitespace-nowrap">小众品牌</a>
          <a href="#" className="px-2.5 py-1 bg-white/10 hover:bg-white/20 rounded-full transition-colors whitespace-nowrap">显瘦搭配</a>
          <a href="#" className="px-2.5 py-1 bg-white/10 hover:bg-white/20 rounded-full transition-colors whitespace-nowrap">口红测评</a>
        </div>
      </div>
    </section>
  );
}